export class SoftwareIntegrations {
  data = [
    {value: 'sitelink', label: 'SiteLink'},
    {value: 'storage-commander', label: 'Storage Commander'},
    {value: 'uhaul', label: 'Web Self Storage'},
    {value: 'none', label: 'No API integration'},
  ];
}



// WEBPACK FOOTER //
// ./src/ng2/app/models/softwareIntegrations.ts